(() => {
  const questionsPerPage = 5;

  const initializePagination = (scope = document) => {
    scope
      .querySelectorAll("[data-collapsible-tabs-pagination]")
      .forEach((container) => {
        if (container.dataset.paginationInitialized === "true") return;

        const questions = Array.from(
          container.querySelectorAll("[data-collapsible-tabs-question]"),
        );
        const previousButton = container.querySelector(
          "[data-pagination-previous]",
        );
        const nextButton = container.querySelector("[data-pagination-next]");
        const pageCount = Math.ceil(questions.length / questionsPerPage);
        let currentPage = 0;

        if (!previousButton || !nextButton || pageCount < 2) return;

        const renderPage = () => {
          questions.forEach((question, index) => {
            const isVisible =
              Math.floor(index / questionsPerPage) === currentPage;
            question.hidden = !isVisible;

            if (!isVisible) {
              question.querySelectorAll("details[open]").forEach((details) => {
                details.open = false;
              });
            }
          });

          previousButton.disabled = currentPage === 0;
          nextButton.disabled = currentPage === pageCount - 1;
        };

        previousButton.addEventListener("click", () => {
          if (currentPage === 0) return;
          currentPage -= 1;
          renderPage();
        });

        nextButton.addEventListener("click", () => {
          if (currentPage === pageCount - 1) return;
          currentPage += 1;
          renderPage();
        });

        container.dataset.paginationInitialized = "true";
        renderPage();
      });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializePagination());
  } else {
    initializePagination();
  }

  document.addEventListener("shopify:section:load", (event) =>
    initializePagination(event.target),
  );
})();
